import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = route.queryParamMap.get('token');
  if (token) {
    authService.setToken(token);
    
    // Remove token from query parameters without reloading the page
    return router.createUrlTree([], {
      queryParams: { token: null, returnUrl: null },
      queryParamsHandling: 'merge',
      preserveFragment: true
    });
  }

  const loggedIn = await firstValueFrom(authService.isLoggedIn());

  if (loggedIn) {
    return true;
  } else {
    const returnUrl = window.location.origin + state.url;
    window.location.href = `${environment.normalUserPageUrl}/auth/login?returnUrl=${encodeURIComponent(returnUrl)}`;
    return false;
  }
};
